import { forwardRef, type ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const variants: Record<Variant, string> = {
  primary: 'bg-bit2me text-white hover:bg-bit2me-mid disabled:bg-ink-muted',
  secondary:
    'border border-line bg-surface-white text-ink-primary hover:border-ink-primary disabled:bg-surface-soft',
  ghost: 'text-ink-secondary hover:text-ink-primary',
  danger: 'border border-bad/30 bg-surface-white text-bad hover:bg-bad/5 disabled:opacity-50',
};

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
};

export const Button = forwardRef<HTMLButtonElement, Props>(
  ({ variant = 'primary', className = '', ...props }, ref) => (
    <button
      ref={ref}
      className={`inline-flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-4 text-sm font-medium transition-colors disabled:cursor-not-allowed ${variants[variant]} ${className}`}
      {...props}
    />
  ),
);
Button.displayName = 'Button';
